import { useMemo } from "react";
import { useNetworkState } from "@uidotdev/usehooks";
import { InternetStatusContext, InternetStatusContextType } from "./InternetStatusContext";

export interface InternetStatusProviderProps {
  children: React.ReactNode;
}

const allowedEffectiveTypes = ["slow-2g", "2g", "3g", "4g"] as const;

function normalizeEffectiveType(value: string | null | undefined): InternetStatusContextType["effectiveType"] {
  if (!value) return null;

  return allowedEffectiveTypes.includes(value as (typeof allowedEffectiveTypes)[number]) ? (value as InternetStatusContextType["effectiveType"]) : null;
}

export function InternetStatusProvider({ children }: InternetStatusProviderProps) {
  const networkState = useNetworkState();

  const value: InternetStatusContextType = useMemo(() => {
    const online = Boolean(networkState.online);

    return {
      online,
      downlink: networkState.downlink ?? null,
      downlinkMax: networkState.downlinkMax ?? null,
      effectiveType: normalizeEffectiveType(networkState.effectiveType),
      rtt: networkState.rtt ?? null,
      saveData: networkState.saveData ?? null,
      type: networkState.type ?? null,
      isOnline: online,
      connectionStatus: online ? "online" : "offline",
    };
  }, [networkState]);

  return <InternetStatusContext value={value}>{children}</InternetStatusContext>;
}
